module.exports = __webpack_public_path__ + "img/slide_3.fe31f08.jpg";